class QueueModel {

    constructor(queue) {
        const { queueId } = queue;
        this.queueId = queueId;
    }

}

export default QueueModel;